import { StorageService, StorageKey } from '../services';
import { User, UserGroup } from '../models';

export const updateLocalStorage = async (user: User, storageService: StorageService, userGroups: Array<UserGroup>) => {
  storageService.set(StorageKey.currentUser, user);
  const currentUser = storageService.get(StorageKey.currentUser);
  const currentPermissions = [];
  const currentContracts = [];
  currentUser.groupIds = [];
  const userGroupUser = userGroups.filter(userGrp => userGrp.userIds.indexOf(currentUser.id) >= 0);
  storageService.remove(StorageKey.currentContracts);
  storageService.remove(StorageKey.currentPermissions);
  storageService.remove(StorageKey.currentUser);
  userGroupUser.forEach(userGrp => {
    if (currentUser.groupIds.indexOf(userGrp.id) < 0) {
      currentUser.groupIds.push(userGrp.id);
    }
    if (currentPermissions.find(p => p.contractId === userGrp.contractId)) {
      userGrp.permissions.forEach(permission => {
        currentPermissions.find(pCurrent => {
          if (pCurrent.contractId === userGrp.contractId && pCurrent.actionIds.indexOf(permission) < 0) {
            pCurrent.actionIds.push(permission);
          }
        });
      });
    } else {
      currentPermissions.push({
        contractId: userGrp.contractId,
        actionIds: userGrp.permissions
      });
    }
    if (currentContracts.indexOf(userGrp.contractId) < 0) {
      currentContracts.push(userGrp.contractId);
    }
  });
  storageService.set(StorageKey.currentContracts, currentContracts);
  storageService.set(StorageKey.currentUser, currentUser);
  storageService.set(StorageKey.currentPermissions, currentPermissions);
};
export const updateCurrentContracts = async (contractId, storageService: StorageService,  userGroups: Array<UserGroup>)=> {
  const contract = Number(contractId);
  const currentContracts = storageService.get(StorageKey.currentContracts);
  const currentPermissions = storageService.get(StorageKey.currentPermissions);
  const currentUser = storageService.get(StorageKey.currentUser);
  const userGroupUser = userGroups.filter(userGrp => userGrp.contractId === contractId)[0];
  if (userGroupUser?.id) {
    currentUser.groupIds.push(userGroupUser.id);
    storageService.set(StorageKey.currentUser, currentUser);
  }

  let actions = [];
  for ( const permision of currentPermissions ) {
    if(permision.actionIds.length > 100) {
      actions = permision.actionIds;
      break;
    }
  }
  storageService.remove(StorageKey.currentContracts);
  if (currentContracts.indexOf(contract) < 0) {
    currentContracts.push(contract);
    currentPermissions.push({
      contractId: Number(contractId),
      actionIds: actions
    });
  }
  storageService.set(StorageKey.currentContracts, currentContracts);
  storageService.set(StorageKey.currentPermissions, currentPermissions);
};
